import { useState, useRef } from "react";
import { IUseTanyaVideoPlayer } from "./tanya-video-player.types";

export const useTanyaVideoPlayer = (): IUseTanyaVideoPlayer => {
  const playerInitRef = useRef(false);
  const videoInit = useRef(false);

  const [state, setState] = useState({ isPlaying: false });

  const handlePlay = () => {
    if (!videoInit.current) {
      videoInit.current = true;
    }
  };

  const handlePlayerInit = () => {
    if (!playerInitRef.current) {
      setState({
        ...state,
        isPlaying: true
      });
      playerInitRef.current = true;
    }
  };

  return {
    isPlaying: state.isPlaying,
    handlePlay,
    handlePlayerInit
  };
};
